import { Empty } from "antd";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export function EmptyState({ description, action }: { description?: ReactNode; action?: ReactNode }) {
  const { t } = useTranslation("common");
  return (
    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={description ?? t("empty")}>
      {action}
    </Empty>
  );
}
